import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../data.service';
import { MedicalFeeSearchItem } from '../../model/medical-fee/medical-fee-search-item';
import { ReportViewer } from '../../model/report-viewer';
import { MedicalFeeBillPeriodFilter, MedicalFeePeriodFilter, MedicalFeeStateFilter, NoMedicalFeeReasonFilter } from '../../model/medical-fee';
import { MedicalFeePaymentEditInfo } from '../../model/medical-fee/medical-fee-payment-edit-info';
import { MedicalFeePhysicianAliquot } from '../../model/medical-fee/medical-fee-physician-aliquot';

@Injectable({
  providedIn: 'root'
})
export class MedicalFeeService {

  constructor(private http: HttpClient, private dataService: DataService) { }

  private readonly getMedicalFeeSearchItemsEndPoint: string = '/medicalFee/getMedicalFeeSearchItems/';
  private readonly getMedicalFeeReportEndPoint: string = '/medicalFee/getMedicalFeeReport/';
  private readonly getMedicalFeePeriodFiltersEndPoint: string = '/medicalFee/getMedicalFeePeriodFilters/';
  private readonly getMedicalFeeBillPeriodFiltersEndPoint: string = '/medicalFee/getMedicalFeeBillPeriodFilters/';
  private readonly getMedicalFeeStateFiltersEndPoint: string = '/medicalFee/getMedicalFeeStateFilters/';
  private readonly getNoMedicalFeeReasonFiltersEndPoint: string = '/medicalFee/getNoMedicalFeeReasonFilters/';
  private readonly createMedicalFeeReportEndPoint: string = '/medicalFee/createMedicalFeeReport/';
  private readonly getMedicalFeePhysicianAliquotsEndPoint: string = '/medicalFee/getMedicalFeePhysicianAliquots/';

  async getMedicalFeePhysicianAliquots( physicianId: number,
    from: Date, to: Date ): Promise<MedicalFeePhysicianAliquot[]> {

      let toUtc = '';
      let fromUtc = '';

      if ( from ) {
        fromUtc = new Date(from.getFullYear(),
        from.getMonth(), from.getDate()).toDateString();
      }

      if ( to ) {
        toUtc = new Date(to.getFullYear(),
        to.getMonth(), to.getDate()).toDateString();
      }

    const param = { physicianId, from: fromUtc, to: toUtc };

    return await this.dataService
          .get<MedicalFeePhysicianAliquot[]>(this.getMedicalFeePhysicianAliquotsEndPoint, param)
          .toPromise();
  }

  async createMedicalFeeReport( medicalFeePaymentEditInfo: MedicalFeePaymentEditInfo ): Promise<ReportViewer> {

    return await this.dataService.post<ReportViewer>(this.createMedicalFeeReportEndPoint,
      medicalFeePaymentEditInfo).toPromise();
  }

  async getNoMedicalFeeReasonFilters(): Promise<NoMedicalFeeReasonFilter[]> {

    const param = { };

    return await this.dataService
          .get<MedicalFeeStateFilter[]>(this.getNoMedicalFeeReasonFiltersEndPoint, param)
          .toPromise();
  }

  async getMedicalFeeStateFilters(): Promise<MedicalFeeStateFilter[]> {

    const param = { };

    return await this.dataService
          .get<MedicalFeeStateFilter[]>(this.getMedicalFeeStateFiltersEndPoint, param)
          .toPromise();
  }

  async getMedicalFeeBillPeriodFilters(): Promise<MedicalFeeBillPeriodFilter[]> {

    const param = { };

    return await this.dataService
          .get<MedicalFeeBillPeriodFilter[]>(this.getMedicalFeeBillPeriodFiltersEndPoint, param)
          .toPromise();
  }

  async getMedicalFeePeriodFilters(): Promise<MedicalFeePeriodFilter[]> {
    const param = { };
    return await this.dataService.get<MedicalFeePeriodFilter[]>(this.getMedicalFeePeriodFiltersEndPoint, param).toPromise();
  }

  async getMedicalFeeReport(medicalFeeId: number, isManual: boolean): Promise<ReportViewer> {
    const param = { medicalFeeId: medicalFeeId, isManual: isManual };
    return await this.dataService.get<ReportViewer>(this.getMedicalFeeReportEndPoint, param).toPromise();
  }

  async getMedicalFeeSearchItems(physicianId: number, medicalFeePeriodFilterId: number ): Promise<MedicalFeeSearchItem[]> {
    const param = {
      physicianId: physicianId,
      medicalFeePeriodFilterId: medicalFeePeriodFilterId
    };
    return await this.dataService.get<MedicalFeeSearchItem[]>(this.getMedicalFeeSearchItemsEndPoint, param).toPromise();
  }
}
